import { Routes } from '@angular/router'
import { AuthGuard } from '@auth0/auth0-angular'
import { maintenanceGuard } from './core/guards/maintenance.guard'
import { userInitGuard } from './core/guards/user-init.guard'
import { RoutePaths } from './core/data/route-paths.data'
import { Page404Component } from './pages/page404/page404.component'
import { MaintenanceComponent } from './pages/maintenance/maintenance.component'
import { HomeComponent } from './pages/home/home.component'


const removeStartAndEndSlashes = (path: string) => path.replace(/^\/|\/$/g, '')

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [maintenanceGuard, userInitGuard],
    data: {
      module: 'home',
    },
  },
  {
    path: removeStartAndEndSlashes(RoutePaths.Details),
    loadChildren: () => import('./pages/details/details.routes').then(m => m.DETAILS_ROUTES),
    canActivate: [maintenanceGuard, userInitGuard],
    data: {
      module: 'details',
    },
  },
  {
    path: RoutePaths.LegacySearch,
    redirectTo: 'equipment',
    pathMatch: 'prefix'
  },
  {
    path: removeStartAndEndSlashes(RoutePaths.Search),
    loadChildren: () => import('./pages/search/search-page.routes').then(m => m.SEARCH_ROUTES),
    canActivate: [maintenanceGuard, userInitGuard],
    data: {
      module: 'search',
    },
  },
  {
    path: removeStartAndEndSlashes(RoutePaths.Admin),
    loadChildren: () => import('./pages/admin/admin-page.routes').then(m => m.ADMIN_ROUTES),
    canActivate: [maintenanceGuard, AuthGuard],
    data: {
      module: 'admin',
    },
  },
  {
    path: removeStartAndEndSlashes(RoutePaths.Maintenance),
    component: MaintenanceComponent,
    canActivate: [maintenanceGuard, userInitGuard],
    data: {
      module: 'maintenance',
    },
  },
  {
    path: '**',
    component: Page404Component,
    canActivate: [maintenanceGuard, userInitGuard],
    data: {
      module: 'page404',
    },
  }
]
